/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import store from '@/store';
import { removeFromScene } from '../utils/forgeUtils'
import { midpoint, drawLine } from '../utils/threejsUtils'
import { formatLength, debounce, canvas_dimension_line, roundRect } from './../scripts/js/forgeService';
import { getViewPage360 } from '@/scripts/js/forgeviewer';
const THREE = window.THREE;

class MeasurementExtension extends Autodesk.Viewing.Extension {
    constructor(loadedViewer, options) {
        super(loadedViewer, options);
        this.viewer = loadedViewer;
        this.webGLDOM = this.viewer.canvas.parentElement.parentElement.parentElement;
        this.isActive = false;
        let _this = this;
        this.webGLDOM.addEventListener("click",(event)=>{
            _this.onMouseUp(event);
        });
        this.viewer.canvas.addEventListener("mousedown",(event)=>{
            _this.onMouseDown(event);
        });
        this.webGLDOM.addEventListener("mousemove",(event)=>{
            _this.onMouseMove(event);
        },false);

        //geometry
        this.startPoint = null;
        this.endPoint = null;
        this.currentPoint = null;
        this.dimensionLine = null;
        this.dimensionLineMeshes = [];
        //meshes
        this.tempLineMesh = null;

        this.isMeasuring2D = false;

        this.differences = null
    }
    get sceneName() {
        return 'potree-scene';
    }
    get dimensionTextClass() {
        return this.isMeasuring2D ? 'floating-dimension-text-2d' : 'floating-dimension-text';
    }
    load() {
        var _this = this;

        this.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.updateCanvas.bind(this));

        let element = document.getElementById('forgeViewer')

        if (!element) {
            element = document.getElementById('forgePlanViewer')
        }

        if (!element) return false;

        this.canvas = document.getElementById('dimensionCanvas');
        if (!this.canvas) {
            this.canvas = document.createElement('canvas');
            this.canvas.id = 'dimensionCanvas';
            this.canvas.style.position = 'absolute';
            this.canvas.style.top = '0';
            this.canvas.style.left = '0';
            this.canvas.style.pointerEvents = 'none';
            this.canvas.style.zIndex = '100';
            element.appendChild(this.canvas);
        }
        this.canvas.width = element.offsetWidth;
        this.canvas.height = element.offsetHeight;
        this.ctx = this.canvas.getContext('2d');              
        
        window.addEventListener('resize', this.resizeCanvas.bind(this));
        document.addEventListener("keydown", this.onKeyDown);
        return true;
    }
    resizeCanvas() {
        const viewerDiv = document.getElementById('forgeViewer');
        this.canvas.width = viewerDiv.clientWidth;
        this.canvas.height = viewerDiv.clientHeight;
    }

    updateCanvas() {
        if (!this.ctx) return;

        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.drawDimensionLine(!this.endPoint);
    }
    drawDimensionLine(moving = false) {
        if (!this.ctx) return;

        if (!this.dimensionLine) return;

        let v1 = this.dimensionLine.v1;
        let v2 = this.dimensionLine.v2;

        if (!v1 || !v2) return;
    
        // Clear the canvas
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            
        // Colors for lines
        let lineColor = "#1dc7f3";
        let lineColorX = "#e62c2c";
        let lineColorY = "#0BB80B";
        let lineColorZ = "#2C2CF1";        
    
        // Calculate intermediate points for X, Y, Z lines
        let crossY = new THREE.Vector3(v2.x, v2.y, v1.z);
        let crossX = new THREE.Vector3(v2.x, v1.y, v1.z);
    
        // Convert 3D points to 2D canvas coordinates
        let screenV1 = this.viewer.impl.worldToClient(v1);
        let screenV2 = this.viewer.impl.worldToClient(v2);
        let screenCrossY = this.viewer.impl.worldToClient(crossY);
        let screenCrossX = this.viewer.impl.worldToClient(crossX);
    
        this.ctx.lineWidth = 3;
        this.ctx.strokeStyle = lineColor;
        this.ctx.setLineDash([])
        this.ctx.beginPath();
        this.ctx.moveTo(screenV1.x, screenV1.y);
        this.ctx.lineTo(screenV2.x, screenV2.y);
        this.ctx.stroke();
    
        this.ctx.lineWidth = 1;

        const drawIntersectionCircle = (point) => {
            const radius = 4;
            const borderWidth = 2;
            const outerRadius = radius + borderWidth;
            const intersectionColor = "#ff0000";
            const intersectionOuterColor = "#ffff00";
        
            // Fill the inner circle with red color
            this.ctx.setLineDash([])
            this.ctx.beginPath();
            this.ctx.arc(point.x, point.y, radius, 0, 2 * Math.PI, false);
            this.ctx.fillStyle = intersectionColor;
            this.ctx.fill();
        
            // Draw the yellow border
            this.ctx.beginPath();
            this.ctx.arc(point.x, point.y, outerRadius, 0, 2 * Math.PI, false);
            this.ctx.strokeStyle = intersectionOuterColor;
            this.ctx.lineWidth = borderWidth;
            this.ctx.stroke();
        };

        if (!moving)
            drawIntersectionCircle(screenV2);
    
        // Draw X line
        if (v1.x !== v2.x) {
            this.ctx.strokeStyle = lineColorX;
            this.ctx.setLineDash([5, 3]);
            this.ctx.beginPath();
            this.ctx.moveTo(screenV1.x, screenV1.y);
            this.ctx.lineTo(screenCrossX.x, screenCrossX.y);
            this.ctx.stroke();
    
            drawIntersectionCircle(screenCrossX);
        }
    
        // Draw Y line
        if (v1.y !== v2.y) {
            this.ctx.strokeStyle = lineColorY;
            this.ctx.setLineDash([5, 3]);
            this.ctx.beginPath();
            this.ctx.moveTo(screenCrossX.x, screenCrossX.y);
            this.ctx.lineTo(screenCrossY.x, screenCrossY.y);
            this.ctx.stroke();

            drawIntersectionCircle(screenCrossY);
        }
    
        // Draw Z line
        if (v1.z !== v2.z) {
            this.ctx.strokeStyle = lineColorZ;
            this.ctx.setLineDash([5, 3]);
            this.ctx.beginPath();
            this.ctx.moveTo(screenCrossY.x, screenCrossY.y);
            this.ctx.lineTo(screenV2.x, screenV2.y);
            this.ctx.stroke();
    
            drawIntersectionCircle(screenV1);
        }
    
        // Draw rectangles in the middle
        this.drawDimensionText(screenV1, screenV2);
    }        
    drawDimensionText(v1, v2) {
        this.ctx.strokeStyle = "rgba(1, 1, 1, 0)";
        this.ctx.font = "16px Arial";
        let letterDimension = this.ctx.measureText(`X`);
        let middle = midpoint(v1, v2);
        this.differences = this.getDimensionsDifference();
        let formattedDistance = this.getDimensionText();

        let textOffset = this.ctx.measureText(`~ ${formattedDistance}`);
        let totalWidth = textOffset.width + letterDimension.width * 2;
        //draw rectangle behind text 
        this.ctx.fillStyle = '#1dc7f3';
        let left = middle.x - totalWidth / 2;
        roundRect(this.ctx, left - 20, middle.y - 15, totalWidth + 40, 30, 15, "all", true); // 20
        //dimension text
        this.ctx.fillStyle = '#ffffff';
        this.ctx.fillText(`~ ${formattedDistance}`, left + letterDimension.width, middle.y + 5);
        //////////////
        let letterRecLeft = left - 20;
        let letterRecWidth = letterDimension.width * 2 + 20;
        let letterLeft = (left - 10) - letterDimension.width / 2 + letterDimension.width;
        let textRecLeft = left + letterDimension.width * 2;
        let textRecWidth = totalWidth + 20 - letterDimension.width * 2;
        //draw rectangle behind X
        this.ctx.fillStyle = '#e62c2c';
        roundRect(this.ctx, letterRecLeft, middle.y + 20, letterRecWidth, 30, 15, "left", true);
        //letter X
        this.ctx.fillStyle = '#ffffff';
        this.ctx.fillText(`X`, letterLeft, middle.y + 40);
        //draw rectangle behind text X
        roundRect(this.ctx, textRecLeft, middle.y + 20, textRecWidth, 30, 15, "right", true);
        //dimension text X
        this.ctx.fillStyle = '#e62c2c';
        let textLeft = letterRecLeft + letterRecWidth + (textRecWidth - this.ctx.measureText(`${this.differences.x}`).width) / 2;
        this.ctx.fillText(`${this.differences.x}`, textLeft, middle.y + 40);
        ////////////
        //draw rectangle behind Y
        this.ctx.fillStyle = '#0BB80B';
        roundRect(this.ctx, letterRecLeft, middle.y + 55, letterRecWidth, 30, 15, "left", true);
        //letter Y
        this.ctx.fillStyle = '#ffffff';
        this.ctx.fillText(`Y`, letterLeft, middle.y + 75);
        //draw rectangle behind text Y
        roundRect(this.ctx, textRecLeft, middle.y + 55, textRecWidth, 30, 15, "right", true);
        //dimension text Y
        this.ctx.fillStyle = '#0BB80B';
        textLeft = letterRecLeft + letterRecWidth + (textRecWidth - this.ctx.measureText(`${this.differences.y}`).width) / 2;
        this.ctx.fillText(`${this.differences.y}`, textLeft, middle.y + 75);
        ////////////
        if (!this.isMeasuring2D) {
            //draw rectangle behind Z
            this.ctx.fillStyle = '#2C2CF1';
            roundRect(this.ctx, letterRecLeft, middle.y + 90, letterRecWidth, 30, 15, "left", true);
            //letter Z
            this.ctx.fillStyle = '#ffffff';
            this.ctx.fillText(`Z`, letterLeft, middle.y + 110);
            //draw rectangle behind text Z
            roundRect(this.ctx, textRecLeft, middle.y + 90, textRecWidth, 30, 15, "right", true);
            //dimension text Z
            this.ctx.fillStyle = '#2C2CF1';
            textLeft = letterRecLeft + letterRecWidth + (textRecWidth - this.ctx.measureText(`${this.differences.y}`).width) / 2;
            this.ctx.fillText(`${this.differences.z}`, textLeft, middle.y + 110);
        }
    }

    unload() {
        document.removeEventListener("keydown", this.onKeyDown);
        this.viewer.removeEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.updateCanvas.bind(this));
        window.removeEventListener('resize', this.resizeCanvas.bind(this));
        return true;
    }
    onToolbarCreated() {
    }
    deactivate(){
        if(this.snapper) this.snapper.deactivate();        
        this.startPoint = null;
        this.endPoint = null;
        this.currentPoint = null;
        this.dimensionLine = null;
        this.differences = null;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.isActive = false;
    }
    onKeyDown = (event) => {
        if (event.keyCode === 27) {
            this.deactivate();
            store.commit("SET_IS_MEASUREING", false);
        }
    }
    getSnappingPoint(mouse,checkPointCloud) {
        let pointOnModel = null;
        if(this.isMeasuring2D){
            let mouseWorld = this.viewer.clientToWorld(mouse.offsetX, mouse.offsetY, true, true);
            if (mouseWorld)
                pointOnModel = mouseWorld.point;
        }else{
            if(this.snapper){
                let snapResult = this.snapper.getSnapResult();
                pointOnModel = snapResult.intersectPoint;
                if (!pointOnModel)
                    pointOnModel = snapResult.getVertex();
            }
        }
        let pointOnPointCloud = null;
        if(checkPointCloud && !this.isMeasuring2D)
            pointOnPointCloud = store.state.forgeService.getMainExtension().pickNearestPointCloudPoint(mouse);
        if (pointOnModel && !pointOnPointCloud)
            return { isOnModel: true, point: pointOnModel };
        else if (!pointOnModel && pointOnPointCloud)
            return { isOnModel: false, point: pointOnPointCloud };
        else if (pointOnModel && pointOnPointCloud) {
            let cameraPosition = this.viewer.navigation.getPosition();
            if (cameraPosition.distanceTo(pointOnModel) < cameraPosition.distanceTo(pointOnPointCloud))
                return { isOnModel: true, point: pointOnModel };
            else
                return { isOnModel: false, point: pointOnPointCloud };
        }
        return null;
    }
    drawPanoramaDimensionLine() {
        const forgeService = store.state.forgeService;

        if (!forgeService.panoramaViewer) return;

        const page360Viewer = getViewPage360();
        
        if (!page360Viewer) return;

        page360Viewer.clearPanoDimension();
        
        page360Viewer.startPoint = this.dimensionLine.v1.clone();
        page360Viewer.endPoint = this.dimensionLine.v2.clone()
        page360Viewer.updatePanoDimensionLineInformation()
    }
    getDimensionsDifference() {

        let pt1 = this.dimensionLine.v1;
        let pt2 = this.dimensionLine.v2;

        if (this.isMeasuring2D) { 
            if (!store.state.selectedLevel || !store.state.selectedLevel.mappingViewersPointsInfo
                || !store.state.selectedLevel.mappingViewersPointsInfo.isReady()) {
                return 'Level not mapped';
            }

            let pt1_3d = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(pt1);
            let pt2_3d = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(pt2);

            return {
                x: formatLength(Math.abs(pt1_3d.x - pt2_3d.x), store.state.userSettings.displaySettings.displayUnits),
                y: formatLength(Math.abs(pt1_3d.y - pt2_3d.y), store.state.userSettings.displaySettings.displayUnits),
            }
        } else {
            return {
                x: formatLength(store.state.forgeService.view3dToWorldLength(Math.abs(pt1.x - pt2.x)), store.state.userSettings.displaySettings.displayUnits),
                y: formatLength(store.state.forgeService.view3dToWorldLength(Math.abs(pt1.y - pt2.y)), store.state.userSettings.displaySettings.displayUnits),
                z: formatLength(store.state.forgeService.view3dToWorldLength(Math.abs(pt1.z - pt2.z)), store.state.userSettings.displaySettings.displayUnits)
            }
        }
    }
    getDimensionText() {

        let pt1 = this.dimensionLine.v1;
        let pt2 = this.dimensionLine.v2;

        let distance = 0;
        if (this.isMeasuring2D) {
            if(!store.state.selectedLevel || !store.state.selectedLevel.mappingViewersPointsInfo
                || !store.state.selectedLevel.mappingViewersPointsInfo.isReady()){
                    return 'Level not mapped';
                }
            let pt1_3d = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(pt1);
            let pt2_3d = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(pt2);
            distance = pt1_3d.distanceTo(pt2_3d);
        }
        else{
            distance = store.state.forgeService.view3dToWorldLength(pt1.distanceTo(pt2));
        }
        let formatedDistance = formatLength(distance, store.state.userSettings.displaySettings.displayUnits);
        return formatedDistance;
    }
    onMouseMove(mouse) {
        if (!this||!this.dragged) {
            this.dragged = true;
            return;
        }

        if (!this.isActive) return;

        if(this.snapper){
            this.snapper.handleMouseMove(mouse);
            this.snapper.indicator.render();
        }

        let _this = this;

        let highlightPoint = function () {
            let point = _this.getSnappingPoint(mouse, true);
            if (!point)
                return;
            if (_this.startPoint) {
                _this.dimensionLine = new THREE.LineCurve(_this.startPoint.clone(), point.point);
                _this.currentPoint = point.point.clone();

                _this.drawDimensionLine(true);
            }
        }

        highlightPoint()
    }
    onMouseDown(mouse) {
        if (mouse.which != 1)
            return;
        if (!this)
            return;
        this.dragged = false;
    }
    onMouseUp(mouse) {
        if (mouse.which != 1)
            return;
        if (!this || !this.isActive || this.dragged)
            return;
        removeFromScene(this.tempLineMesh, this.viewer, this.sceneName);
        store.state.forgeService.clearElementsByClassName(this.dimensionTextClass);
        let point = this.getSnappingPoint(mouse,true);

        if (!point) return;

        this.viewer.clearSelection();

        if (this.startPoint && this.endPoint) {
            this.startPoint = null;
            this.endPoint = null;
            removeFromScene(this.dimensionLineMeshes,this.viewer,this.sceneName);
            this.dimensionLineMeshes = [];
        }

        if (this.startPoint) {
            this.endPoint = point.point.clone();
            this.dimensionLine = new THREE.LineCurve(this.startPoint.clone(), this.endPoint.clone());

            this.drawDimensionLine();
            this.drawPanoramaDimensionLine();

            store.commit("SET_IS_MEASUREING", false);

            this.isActive = false;

            if (this.snapper) {
                this.snapper.deactivate();
            }

        } else {
            this.startPoint = point.point.clone();
        }
    }

}
Autodesk.Viewing.theExtensionManager.registerExtension('MeasurementExtension', MeasurementExtension);
